module.exports = __webpack_public_path__ + "img/ic-slider-left-control.3f913a25.svg";